import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box
} from '@chakra-ui/react';
import { CategoryType } from '../Table/MaintenanceCategoryTable';
import { CategorySendMessageType } from '../../../constants/MaintenanceConstants';

interface props {
  isOpen: boolean;
  onClose: () => void;
  BrowseData: CategoryType | undefined;
}

const GetMessageTypeName = (messageType: string | undefined) => {
  switch (messageType) {
    case CategorySendMessageType.Signage:
      return '停留場メッセージ';
    case CategorySendMessageType.Obc:
      return 'OBCメッセージ';
    case CategorySendMessageType.Location:
      return '位置情報メッセージ';
    case CategorySendMessageType.Message:
      return '共通メッセージ';
    default:
      return '';
  }
};

export const CategpryBrowseWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, BrowseData } = props;
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='300px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            カテゴリの詳細
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>ID</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.id}
              </Text>

              <Text mt={4}>カテゴリ名</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.name}
              </Text>

              <Text mt={4}>タイプ</Text>
              <Text mt={4} w='100%'>
                {GetMessageTypeName(BrowseData?.type)}
              </Text>

              <Text mt={4}>登録日時</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.created_at}
              </Text>

              <Text mt={4}>更新日時</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.updated_at}
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
